module.exports = __webpack_public_path__ + "img/logo-bratech.b69abaf9.svg";